/* eslint-disable max-lines */
import {
  DEFAULT_SIZES,
  DATA_TYPE,
  COMPONENT_TYPE,
  WIDTH,
  HEIGHT,
} from '@/store/modules/cards/constants';

/*
  Property of allowCards objects:

  id: String,
  width: Enum DEFAULT_SIZES,
  height: Enum DEFAULT_SIZES,
  component: String,
  visible: Boolean,
  hideExpandButton: Boolean,
  hideResizeButton: Boolean,
  notSupportFilter: Boolean,
  dataType: Enum DATA_TYPE,
  props: Object,
*/
export default [
  {
    id: 'BLIP_1',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BaseBlipVariationChart',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    props: {
      title: 'Mensagens Recebidas',
      originalTitle: 'Mensagens Recebidas',
      isExpandedCard: false,
      description: 'Total de mensagens recebidas no periodo (dos contatos para o bot).',
      servicePath: 'getReceivedMessages',
      interval: 'NI',
    },
  },
  {
    id: 'BLIP_2',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BaseBlipVariationChart',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    props: {
      title: 'Mensagens Enviadas',
      originalTitle: 'Mensagens Enviadas',
      isExpandedCard: false,
      description: 'Total de mensagens enviadas no periodo (do bot para os contatos).',
      servicePath: 'getSentMessages',
      interval: 'NI',
    },
  },
  {
    id: 'BLIP_3',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BaseBlipVariationChart',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    props: {
      title: 'Mensagens Ativas',
      originalTitle: 'Mensagens Ativas',
      isExpandedCard: false,
      description: 'Total de mensagens ativas enviadas no período (24 horas após a última interação do contato).',
      servicePath: 'getActiveMessages',
      interval: 'NI',
    },
  },
  {
    id: 'BLIP_4',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BaseBlipVariationChart',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    props: {
      title: 'Total de Contatos Únicos no Período',
      originalTitle: 'Total de Contatos Únicos no Período',
      isExpandedCard: false,
      description: 'Total de contatos únicos no período, que receberam ou enviaram mensagem para o bot.',
      servicePath: 'getActiveIdentity',
      interval: 'NI',
    },
  },
  {
    id: 'BLIP_5',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BaseBlipVariationChart',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    props: {
      title: 'Contatos com Interação no Período',
      originalTitle: 'Contatos com Interação no Período',
      isExpandedCard: false,
      description: 'Total de contatos únicos no período, que enviaram mensagem para o bot.',
      servicePath: 'getEngagedIdentity',
      interval: 'NI',
    },
  },
  {
    id: 'BLIP_6',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BaseBlipLineChart',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    props: {
      title: 'Contatos Únicos por Intervalo',
      originalTitle: 'Contatos Únicos por Intervalo',
      isExpandedCard: false,
      description: 'Contatos únicos por intervalo (dia ou mês), que receberam ou enviaram mensagem para o bot.',
      servicePath: 'getActiveIdentity',
      interval: 'D',
    },
  },
  {
    id: 'BLIP_7',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BaseBlipLineChart',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    props: {
      title: 'Contatos com Interação por Intervalo',
      originalTitle: 'Contatos com Interação por Intervalo',
      isExpandedCard: false,
      description: 'Contatos únicos por intervalo (dia ou mês), que enviaram mensagem para o bot.',
      servicePath: 'getEngagedIdentity',
      interval: 'D',
    },
  },
  {
    id: 'BLIP_8',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BaseBlipLineChart',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    props: {
      title: 'Mensagens Enviadas por Intervalo',
      originalTitle: 'Mensagens Enviadas por Intervalo',
      isExpandedCard: false,
      description: 'Mensagens enviadas por intervalo (dia ou mês), do bot para os contatos.',
      servicePath: 'getSentMessages',
      interval: 'D',
    },
  },
  {
    id: 'BLIP_9',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BaseBlipLineChart',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    props: {
      title: 'Mensagens Recebidas por Intervalo',
      originalTitle: 'Mensagens Recebidas por Intervalo',
      isExpandedCard: false,
      description: 'Mensagens recebidas por intervalo (dia ou mês), do bot para os contatos.',
      servicePath: 'getReceivedMessages',
      interval: 'D',
    },
  },
  {
    id: 'BLIP_10',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BaseBlipLineChart',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    props: {
      title: 'Mensagens Ativas por Intervalo',
      originalTitle: 'Mensagens Ativas por Intervalo',
      isExpandedCard: false,
      description: 'Mensagens ativas enviadas por intervalo (dia ou mês), 24 horas após a última interação do contato.',
      servicePath: 'getActiveMessages',
      interval: 'D',
    },
  },
  {
    id: 'BLIP_11',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BlipMessageVolumeInPeriod',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    props: {
      title: 'Volume de mensagens no período',
      originalTitle: 'Volume de mensagens no período',
      isExpandedCard: false,
      description: 'Gráfico de linha com o total de mensagens enviadas e recebidas, dentro do período selecionado.',
      servicePath: 'getReceivedAndSentMessages',
    },
  },
  {
    id: 'BLIP_12',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipNonEngagedContacts',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    props: {
      title: 'Contatos que não responderam',
      originalTitle: 'Contatos que não responderam',
      isExpandedCard: false,
      description: 'Total de contatos únicos que não responderam a nenhuma mensagem enviada pelo chatbot e não iniciaram nenhuma conversa, no período selecionado.',
      servicePath: 'getMetricsContacts',
    },
  },
  {
    id: 'BLIP_13',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BlipEngagedAndNonEngagedContacts',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    props: {
      title: 'Contatos com interação x Contatos que não responderam',
      originalTitle: 'Contatos com interação x Contatos que não responderam',
      isExpandedCard: false,
      description: 'Gráfico de linha com o total de contatos únicos que não responderam e contatos únicos que interagiram com o chatbot, dentro do período selecionado.',
      servicePath: 'getMetricsContacts',
    },
  },
  {
    id: 'BLIP_14',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipRejectionRate',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    props: {
      title: 'Taxa de rejeição',
      originalTitle: 'Taxa de rejeição',
      isExpandedCard: false,
      description: 'Cálculo da porcentagem do total de contatos únicos que não responderam ao chatbot dividido pelo número total de contatos únicos no período selecionado. Calculado através da seguinte fórmula: Total de Contatos que não responderam / Total de contatos únicos * 100%.',
      servicePath: 'getMetricsContacts',
    },
  },
  {
    id: 'BLIP_15',
    width: WIDTH.LARGE,
    height: HEIGHT.LARGE,
    component: 'BlipActiveMessagesByChannel',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    props: {
      title: 'Mensagens ativas por canal',
      originalTitle: 'Mensagens ativas por canal',
      isExpandedCard: false,
      description: 'Tabela com o total de mensagens ativas enviadas por canal no período de tempo selecionado. São consideradas mensagens ativas as mensagens que foram enviadas pelo chatbot após 24 horas do recebimento da última mensagem enviada pelo contato.',
      servicePath: 'getActiveMessagesPerDomain',
      interval: 'NI',
    },
  },
  {
    id: 'BLIP_16',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipEngagementRate',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    props: {
      title: 'Taxa de interação',
      originalTitle: 'Taxa de interação',
      isExpandedCard: false,
      description: 'Cálculo da porcentagem do total de contatos únicos que responderam e interagiram com o chatbot sobre o número total de contatos únicos no período selecionado. Calculado através da seguinte fórmula: Total de Contatos com Interação / Total de contatos únicos * 100%.',
      servicePath: 'getMetricsContacts',
    },
  },
  {
    id: 'BLIP_17',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipTotalSentAndReceivedMessages',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    props: {
      title: 'Total de mensagens trafegadas',
      originalTitle: 'Total de mensagens trafegadas',
      isExpandedCard: false,
      description: 'Total de mensagens enviadas e recebidas pelo chatbot no fluxo conversacional. Inclui, também, mensagens trafegadas no Blip Desk, entre os contatos e atendentes.',
      servicePath: 'getReceivedAndSentMessages',
      interval: 'NI',
    },
  },
  {
    id: 'BLIP_18',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipEventTrackCount',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    isEvent: true,
    props: {
      title: 'Total de Eventos Personalizados',
      originalTitle: 'Total de Eventos Personalizados',
      isExpandedCard: false,
      description: 'Número total de Eventos Personalizados de acordo com as opções aplicadas no filtro, dentro do período selecionado.',
      servicePath: 'getEventTrackCount',
    },
  },
  {
    id: 'BLIP_19',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'BlipEventTrackHorizontalStackedBar',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    isEvent: true,
    props: {
      title: 'Distribuição de Eventos Personalizados',
      originalTitle: 'Distribuição de Eventos Personalizados',
      isExpandedCard: false,
      description: 'Divisão dos Eventos Personalizados de acordo com as opções aplicadas no filtro, dentro do período selecionado.',
      servicePath: 'getEventTrack',
    },
  },
  {
    id: 'BLIP_20',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'BlipEventTrackPieChart',
    componentType: COMPONENT_TYPE.DONUT,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    isEvent: true,
    props: {
      title: 'Distribuição de Eventos Personalizados (Percentual)',
      originalTitle: 'Distribuição de Eventos Personalizados (Percentual)',
      isExpandedCard: false,
      description: 'Divisão dos Eventos Personalizados de acordo com as opções aplicadas no filtro, dentro do período selecionado',
      servicePath: 'getEventTrack',
    },
  },
];
